/**
 * Decide how to open the quote-request Bootstrap dialog.
 *
 * Peek (#taskModal.show): nest without a second backdrop.
 * Full-page task show: promote to body and use a normal backdrop so the dialog
 * stacks above the overlay (same rationale as turbo_frame#modal on body).
 *
 * @param {{ taskModalShowing: boolean }} opts
 * @returns {{ nested: boolean, backdrop: boolean, promoteToBody: boolean }}
 */
export function quoteRequestOpenOptions({ taskModalShowing }) {
  if (taskModalShowing) {
    return { nested: true, backdrop: false, promoteToBody: false }
  }

  return { nested: false, backdrop: true, promoteToBody: true }
}
